import type { Complex } from '@placer-ui/types';
import { ENTITY_SECTION_MARKET, ENTITY_SECTION_PROPERTY } from 'core/constants/report-type';
import { IPoi } from 'features/explore/model/poi-model/poi';

export const isPoiMarket = (entity: IPoi) => {
    return entity.entitySection.get() === ENTITY_SECTION_MARKET;
};
export const isMarketEntity = (entity: Complex) => {
    return entity.entity_section === ENTITY_SECTION_MARKET;
};
export const isRegionEntity = (entity: Complex) => {
    return (
        entity.entity_section === ENTITY_SECTION_PROPERTY && entity.category_info.group === 'Region'
    );
};
export const isMarketEntityWithRegionTwins = (entity: Complex) => {
    return isMarketEntity(entity) && !!entity?.twin_region_ids?.length;
};
